import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { TYPES } from 'src/common/constants';
import * as client from '../../services/client';
import { PATHS } from 'src/common/constants';
import 'react-toastify/dist/ReactToastify.css';
import { baseUrl } from 'src/Tenants';
import { fetchUserSuites } from './userSuites';

export const fetchAuthenticatedUserDone = (payload) => ({
  type: TYPES.FETCH_AUTHENTICATED_USER_DONE,
  payload,
});

export const fetchAuthenticatedUser = () => (dispatch, getState) => {
  const user = selectAuthenticatedUser(getState());
  if (!user) {
    let data = localStorage.getItem('user');
    dispatch(fetchAuthenticatedUserDone(JSON.parse(data)));
  }
};

const savePropertyManagerDetails = (payload) => ({
  type: TYPES.PROPERTY_MANAGER_DETAILS_DONE,
  payload: payload,
});

const savePropertyManagerCalendlyLinkDone = (payload) => ({
  type: TYPES.PROPERTY_MANAGER_CALENDLY_DONE,
  payload: payload,
});

export const getNewAuthorizationToken = async (userId) => {
  const apiUrl = baseUrl + 'api/UserManagement/Token/' + userId;
  const response = await client.apiReq(apiUrl, 'GET', true);

  if (client.isApiError(response)) {
    return;
  }

  const responseJson = await response.json();

  localStorage.setItem('auth', JSON.stringify(responseJson.auth));
};

export const fetchPropertyDetailsByProperty =
  (propertyId, fetchLink) => (dispatch) => {
    return client
      .fetchPropertyDetailsByProperty(propertyId)
      .then((response) => {
        if (response.status === 200) {
          response.json().then((responseJson) => {
            if (fetchLink && fetchLink === true) {
              dispatch(fetchCalendlyLink(responseJson.email));
            }
            dispatch(savePropertyManagerDetails(responseJson));
          });
        } else {
          // this.setState({ propertyDetails: []})
        }
      });
  };

export const fetchCalendlyLink = (email) => (dispatch) => {
  client.fetchCalendlyLink(email).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responseJson) => {
        if (responseJson.statusCode === 200) {
          if (responseJson.data) {
            dispatch(
              savePropertyManagerCalendlyLinkDone({
                calendlyLink: responseJson.data.calendarLink,
                calendlyAPIKey: responseJson.data.calendlyAPIKey,
              })
            );
          } else {
            dispatch(savePropertyManagerCalendlyLinkDone({ calendlyLink: '' }));
          }

          // responseJson.data.user.scheduling_url
        } else if (responseJson.statusCode === 400) {
          dispatch(savePropertyManagerCalendlyLinkDone({ calendlyLink: '' }));

          //  alert('No calendar activation for this Property Developer');
        }
      });
    }
  });
};

//TODO: both responseJson and Data are the same object. Need to refactor this to only use one of the 2
export const setPermissions = async (responseJson, history, data, dispatch) => {
  let settings = {};
  if (responseJson && responseJson.permissions.ownerId) {
    for (
      let i = 0;
      i < responseJson.permissions.components[0].childComponents.length;
      i++
    ) {
      let childData = responseJson.permissions.components[0].childComponents[i];

      let result = await setOperation(childData.operations);
      settings = { ...settings, [childData.name]: result };

      for (let j = 0; j < childData.childComponents.length; j++) {
        let childOperationData = childData.childComponents[j];

        let result1 = await setOperation(childOperationData.operations);
        settings = { ...settings, [childOperationData.name]: result1 };
      }
    }
  }

  const homeOwnerIsRedirectFromEmailTemplateURL = window.location.href;
  localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');

  let url = new URL(homeOwnerIsRedirectFromEmailTemplateURL);
  let URLparams = new URLSearchParams(url.search);

  if (
    URLparams.has('isShowFeedBackReportPopup') &&
    URLparams.has('ServiceRequestId')
  ) {
    let ServiceRequestId = URLparams.get('ServiceRequestId');

    localStorage.setItem(
      'IsHomerNavigatFromFeedBackTemplate',
      JSON.stringify({
        IsHomerNavigatFromFeedBackTemplate: true,
        ServiceRequestId: ServiceRequestId,
      })
    );
  }

  setTimeout(() => {
    if (
      data &&
      data.roles &&
      data.roles.length > 0 &&
      data.roles[0].role.name === 'Home Owner'
    ) {
      dispatch(fetchUserSuites(data.id, 'logincall', data.roles[0].role.name));

      if (localStorage.getItem('user').isDashboardAccess === false) {
        localStorage.setItem('propertyId', data.propertyId);
      }

      history.push(PATHS.DASHBOARD);
    } else {
      history.push(PATHS.SERVICE_REQUESTS_LIST);
    }
  }, 1000);
  localStorage.setItem('permissions', JSON.stringify(settings));
};

export const setOperation = async (operations) => {
  let list = [];
  if (operations && operations.length > 0) {
    operations.map((operation) => {
      list = [...list, operation.name];
    });
    return list;
  } else {
    return list;
  }
};

export const updateAuthenticatedUser = (user) => ({
  type: TYPES.UPDATE_AUTHENTICATED_USER,
  payload: user,
});
